import React from "react"
import { VictoryAxis, VictoryLabel } from "victory"

const YAxis = () => {
  return (
    <VictoryAxis
      key="y-axis"
      className="yAxis"
      dependentAxis
      axisLabelComponent={<VictoryLabel dy={20} />}
      tickFormat={(tick, index, ticks) => tick + "%"}
      style={{
        axis: { visibility: "hidden" },
        grid: { stroke: "#E0E0E0" },
        tickLabels: { fontSize: 10 },
      }}
    />
  )
}

export default YAxis
